<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Clientes</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            v-model="searchTerm"
                            placeholder="Buscar por NIT, Nombre o Contacto..."
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <argon-button
                        class="mt-0"
                        color="success"
                        fullWidth
                        size="xs"
                        @click="toCreate"
                    >
                        Agregar Nuevo
                    </argon-button>
                </div>
            </div>
        </div>

        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4">
                                Nombre / Razón Social
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                DUI
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                Contacto
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Tipo
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Dirección Fiscal
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                                Fecha Creación
                            </th>
                            <th class="text-secondary opacity-7 text-center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="filteredRows.length === 0">
                            <td colspan="7" class="text-center py-4 text-muted">
                                {{ searchTerm ? `No hay coincidencias con la búsqueda de "${searchTerm}".` : 'No se encontraron clientes.' }}
                            </td>
                        </tr>

                        <tr
                            v-for="(client, index) in filteredRows"
                            :key="index"
                        >
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">
                                            {{ client.name }}
                                        </h6>
                                        <p v-if="client.business_name" class="text-xs text-secondary mb-0">
                                            ({{ client.business_name }})
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 ps-2">{{ client.nit || 'N/A' }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ client.email || 'Sin Correo' }}</p>
                                <p class="text-xs text-secondary mb-0">{{ client.phone || 'Sin Teléfono' }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ getClientTypeText(client.type) }}
                                </p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ client.fiscal_address ? (client.fiscal_address.substring(0, 30) + (client.fiscal_address.length > 30 ? '...' : '')) : 'Sin dirección' }}
                                </p>
                            </td>
                            <td class="text-center">
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ $formatDate ? $formatDate(client.created_at) : client.created_at }}
                                </p>
                            </td>
                            <td class="align-middle text-center">
                                <a
                                    @click="toEdit(client.id)"
                                    class="btn bg-success mx-1"
                                    data-toggle="tooltip"
                                    data-original-title="Editar cliente"
                                >
                                    <i class="fa fa-pen text-white text-sm opacity-10"></i>
                                </a>
                                <a
                                    @click="deleteClient(client.id, client.name)"
                                    class="btn bg-danger mx-1"
                                    data-toggle="tooltip"
                                    data-original-title="Eliminar cliente"
                                >
                                    <i class="fa fa-trash text-white text-sm opacity-10"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import Swal from 'sweetalert2';
const clientTypeMap = {
    'NATURAL': 'Persona Natural',
    'JURIDICA': 'Persona Jurídica (Contribuyente)',
    'EXCLUIDO': 'Sujeto Excluido',
    'EXCENTA': 'ONG',
    // Aquí puedes añadir más tipos si es necesario
};
export default {
    name: "ClientsTable",
    components: { ArgonButton },
    props: {
        clients: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            searchTerm: null,

        };
    },
    computed: {
        filteredRows() {
            if (!this.searchTerm) {
                return this.clients;
            } else {
                const searchLower = this.searchTerm.toLowerCase();
                return this.clients.filter(client => {
                    const clientName = (client.name || client.business_name || '').toString().toLowerCase();
                    const nit = client.nit ? client.nit.toString().toLowerCase() : '';
                    const phone = client.phone ? client.phone.toString().toLowerCase() : '';
                    const email = client.email ? client.email.toString().toLowerCase() : '';

                    // Búsqueda en Nombre, Razón Social, NIT, Teléfono y Email
                    return clientName.includes(searchLower) ||
                           (client.business_name && client.business_name.toLowerCase().includes(searchLower)) ||
                           nit.includes(searchLower) ||
                           phone.includes(searchLower) ||
                           email.includes(searchLower);
                });
            }
        },

    },
    methods: {
        getClientTypeText(clientCode) {
            return clientTypeMap[clientCode] || clientCode;
        },
        toCreate() {
            this.$router.push('/clients/create');
        },
        toEdit(clientId) {
            this.$router.push(`/clients/${clientId}`);
        },
        deleteClient(clientId, clientName) {
            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const config = {
                headers: { 'Authorization': `Bearer ${token}` }
            };

            Swal.fire({
                title: `¿Eliminar cliente ${clientName}?`,
                text: 'Esta acción no se puede deshacer y puede causar problemas si el cliente tiene facturas asociadas.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(apiURL + 'clients/' + clientId, config)
                    .then(() => {
                        Swal.fire('Eliminado', 'El cliente fue eliminado correctamente.', 'success');
                        this.$emit('client-deleted');
                    })
                    .catch((error) => {
                        console.error('Error al eliminar cliente:', error.response || error);
                        Swal.fire('Error', 'No se pudo eliminar el cliente. Verifique si tiene documentos asociados.', 'error');
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
.table th, .table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>